export default {
  items: [
    {
      name: 'Bảng tin',
      url: '/dashboard',
      icon: 'icon-speedometer',
      role: ["admin","superAdmin"],
    },
    {
      name: 'Cổ phiếu',
      url: '/stock',
      icon: 'cui-credit-card',
      role: ["admin","superAdmin"],
    },
    {
      name: 'Thành viên',
      url: '/users/overview',
      icon: 'cui-people',
      role: ["admin","superAdmin"],
      children: [
        {
          name: 'Tổng quan',
          url: '/users/overview',

        },
        {
          name: 'Danh sách',
          url: '/users/list',

        },
        {
          name: 'Thêm mới',
          url: '/users/new',

        }
      ]
    },
    {
      name: 'Quản trị',
      url: '/admin',
      icon: 'cui-user',
      role: ["superAdmin"],
      children: [
        {
          name: 'Tất cả',
          url: '/admin/list',

        },
        {
          name: 'Thêm mới',
          url: '/admin/new',

        }
      ]
    },

    {
      name: 'Logs',
      url: '/logs',
      icon: 'cui-settings',
      role: ["superAdmin"],
    },


    {
      name: 'Cài đặt',
      url: '/settings',
      icon: 'cui-settings',
      role: ["superAdmin"],
      children: [
        {
          name: 'Tổng quan',
          url: '/settings/overview',

        },
      ]
    },
    {
      name: 'Thoát',
      url: '/Logout',
      icon: 'fa fa-sign-out',
      role: ["admin","superAdmin"],
    }
  ]
}
